import { Link } from "react-router-dom";
import Card from "components/card";
import Toast from "components/cms/Toast";

export default function ResourceList({
  title,
  description,
  createHref,
  createLabel,
  columns,
  items,
  total,
  loading,
  error,
  toast,
  onCloseToast,
  emptyText,
  deletingId,
  onDelete,
  editHref,
}) {
  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={onCloseToast} />
      <Card extra="overflow-hidden rounded-2xl border border-gray-200 shadow-none dark:!border-white/10">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-purple-100 bg-gradient-to-r from-[#F3F0FF] to-white px-4 py-3 dark:border-white/10 dark:from-navy-800 dark:to-navy-800">
          <div>
            <h3 className="text-base font-bold text-navy-700 dark:text-white">{title}</h3>
            <p className="text-xs text-gray-500">
              {description}
              {typeof total === "number" ? ` · ${total} item${total === 1 ? "" : "s"}` : ""}
            </p>
          </div>
          <Link
            to={createHref}
            className="inline-flex rounded-lg bg-gradient-to-r from-[#4C3FE8] to-[#A855F7] px-3 py-1.5 text-xs font-medium text-white hover:opacity-90"
          >
            {createLabel}
          </Link>
        </div>

        {error ? (
          <p className="px-4 py-6 text-sm text-red-500">{error}</p>
        ) : loading ? (
          <p className="px-4 py-6 text-sm text-gray-500">Loading…</p>
        ) : items.length === 0 ? (
          <p className="px-4 py-6 text-sm text-gray-500">{emptyText}</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[720px] text-left">
              <thead>
                <tr className="border-b border-gray-100 text-[11px] font-bold uppercase tracking-[0.12em] text-[#6A4CF0] dark:border-white/10">
                  {columns.map((column) => (
                    <th key={column.key} className="px-4 py-3">
                      {column.label}
                    </th>
                  ))}
                  <th className="px-4 py-3 text-right"> </th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr
                    key={item._id}
                    className="border-b border-gray-50 text-sm text-navy-700 last:border-0 dark:border-white/5 dark:text-white"
                  >
                    {columns.map((column) => (
                      <td key={column.key} className="px-4 py-3">
                        {column.render ? column.render(item) : item[column.key] || "—"}
                      </td>
                    ))}
                    <td className="whitespace-nowrap px-4 py-3 text-right">
                      <div className="inline-flex items-center gap-2">
                        <Link
                          to={editHref(item)}
                          className="inline-flex rounded-lg bg-gradient-to-r from-[#4C3FE8] to-[#A855F7] px-3 py-1.5 text-xs font-medium text-white hover:opacity-90"
                        >
                          Edit
                        </Link>
                        <button
                          type="button"
                          disabled={deletingId === item._id}
                          onClick={() => onDelete(item)}
                          className="inline-flex rounded-lg border border-red-200 px-3 py-1.5 text-xs font-medium text-red-600 hover:bg-red-50 disabled:opacity-50 dark:border-red-500/40 dark:text-red-400 dark:hover:bg-red-500/10"
                        >
                          {deletingId === item._id ? "Deleting…" : "Delete"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
